import { Skeleton } from "@xola/ui-kit";
import { range } from "lodash";
import React from "react";
import { PurchaseItem } from "types";

export const SummarySkeleton = ({ item }: { item: PurchaseItem }) => {
    const rows = Math.max(8, item.quantity);
    return (
        <div className="space-y-2" data-testid="summary-skeleton">
            {range(0, rows).map((value) => (
                <Skeleton
                    key={value}
                    height={20}
                    classNames={{
                        container: "!bg-secondary-light !bg-opacity-50 !border-none",
                    }}
                />
            ))}
        </div>
    );
};
